import { lazy } from "react";
import ImageCollection from "../../../../../CommonElements/ImageCollection";
import { Col, Row } from "reactstrap";
import { H5, LI, P, UL } from "../../../../../AbstractElements";
import { EXCEL, Images, PDF } from "../../../../../utils/Constant";
import IframeView from "../../../../../CommonElements/Iframe";
import { ExtensionTypes } from "../../../../reimbursement/types";
import { handleDownload } from "../../../../../utils/fileUtils";

const CommonModal = lazy(
  () => import("../../../../../Component/Ui-Kits/Modal/Common/CommonModal")
);

export interface IExpenseAttachmentCollectionModalProps {
  isOpen: boolean;
  onClose: () => void;
  attachmentCollection: ExtensionTypes;
}

const ExpenseAttachmentCollectionModal = ({
  isOpen,
  onClose,
  attachmentCollection,
}: IExpenseAttachmentCollectionModalProps) => {
  return (
    <CommonModal
      headerClassName="bg-primary"
      titleClassName="text-white"
      title="Add Expense"
      modalBodyClassName="ps-lg-4"
      centered
      toggle={onClose}
      isOpen={isOpen}
      showFooter={false}
    >
      {attachmentCollection &&
        attachmentCollection?.img &&
        Array.isArray(attachmentCollection.img) && (
          <ImageCollection
            title={Images} // your title
            images={attachmentCollection.img}
            handleDownload={handleDownload}
          />
        )}

      {attachmentCollection &&
        attachmentCollection.pdf &&
        Array.isArray(attachmentCollection.pdf) &&
        attachmentCollection?.pdf?.length > 0 &&
        attachmentCollection?.pdf?.map((file: string, index: number) => (
          <Row>
            <H5 className="text-underline mb-3">{PDF}</H5>
            <Col xs="12" key={index}>
              <div className="w-100 h-100">
                <IframeView file={file} heightValue="500px" />
              </div>
            </Col>
          </Row>
        ))}
      {attachmentCollection &&
        attachmentCollection?.excel &&
        Array.isArray(attachmentCollection?.excel) &&
        attachmentCollection?.excel?.length > 0 && (
          <Row>
            <H5 className="text-underline mb-3">{EXCEL}</H5>
            <UL>
              {attachmentCollection?.excel?.map((file) => (
                <LI>
                  <P className="w-100 pointer position-relative text-wrap d-block overflow-hidden m-0">
                    <a href={file} target="_blank" download>
                      {file}
                    </a>
                  </P>
                </LI>
              ))}
            </UL>
          </Row>
        )}
    </CommonModal>
  );
};

export default ExpenseAttachmentCollectionModal;
